var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcNotas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.1266 10.3646V32.5351C32.1266 34.448 30.5766 36 28.6617 36H11.4629C9.54997 36 8 34.448 8 32.5351V10.3646C8 8.56349 9.37144 7.08415 11.1255 6.91542C11.2353 6.90561 11.3491 6.89972 11.4629 6.89972H28.6617C28.7755 6.89972 28.8873 6.90561 28.9991 6.91542C30.7551 7.08611 32.1266 8.56349 32.1266 10.3646Z",
    fill: "white",
    stroke: "#228C80",
    strokeWidth: 1.00258,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4796 8.80879V30.0591C29.4796 31.8936 28.2691 33.3788 26.776 33.3788H13.3501C11.8551 33.3788 10.6465 31.8916 10.6465 30.0591V8.80879C10.6465 8.10443 10.8231 7.45305 11.1272 6.91743C11.2371 6.90762 11.3508 6.90173 11.4646 6.90173H28.6634C28.7772 6.90173 28.889 6.90762 29.0009 6.91743C29.305 7.45305 29.4816 8.1064 29.4816 8.80879H29.4796Z",
    fill: "#F5FBFA",
    stroke: "#228C80",
    strokeWidth: 1.00258,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9941 15.8288H26.8146",
    stroke: "#228C80",
    strokeWidth: 1.00258,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6621 19.4722H27.2587",
    stroke: "#228C80",
    strokeWidth: 1.00258,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6621 23.561H27.2587",
    stroke: "#228C80",
    strokeWidth: 1.00258,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6621 28.0029H27.2587",
    stroke: "#228C80",
    strokeWidth: 1.00258,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7147 13.19H15.7037V11.1789C15.7037 10.8905 15.4702 10.657 15.1798 10.657C14.8895 10.657 14.6579 10.8905 14.6579 11.1789V13.19H12.6469C12.3585 13.19 12.123 13.4235 12.123 13.7119C12.123 14.0003 12.3565 14.2338 12.6469 14.2338H14.6579V16.2448C14.6579 16.5332 14.8914 16.7667 15.1798 16.7667C15.4682 16.7667 15.7037 16.5332 15.7037 16.2448V14.2338H17.7147C18.0012 14.2338 18.2366 14.0003 18.2366 13.7119C18.2366 13.4235 18.0012 13.19 17.7147 13.19Z",
    fill: "#228C80"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6106 6.50547C25.5263 5.10853 24.3707 4 22.9522 4H17.1741C15.8105 4 14.6922 5.02612 14.5333 6.34654H14.5156V8.81276H25.6087V6.50742L25.6106 6.50547Z",
    fill: "#F9839A",
    stroke: "#228C80",
    strokeWidth: 1.00258,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNotas);
export default __webpack_public_path__ + "static/media/Ic_notas.d90c8bd1b342c890956ba7d1e883cb2c.svg";
export { ForwardRef as ReactComponent };